import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"

import { graphql } from "gatsby"
import Banner from "../components/hero/banner-workato.js"
import loadable from "@loadable/component"
import pMinDelay from "p-min-delay"

const WorkatoSections = loadable(() =>
  pMinDelay(import("../components/WorkatoSections"), 1000)
)

class Workato extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    return (
      <Layout
        location={this.props.location}
        title={siteTitle}
        banner={<Banner />}
      >
        <Seo
          title="Workato Solutions | Quandary Consulting Group"
          description="Workato unlocks seamless integrations between your business systems, connecting apps effortlessly its intelligent automation platform. Learn more."
        />
        <WorkatoSections props={this.props} />
      </Layout>
    )
  }
}

export default Workato

export const workatoQuery = graphql`
  query workatoQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
    allSanityCaseStudy(sort: { fields: [publishedAt], order: DESC }, limit: 3) {
      edges {
        node {
          title
          publishedAt(formatString: "MMMM DD, YYYY")
          mainImage {
            asset {
              gatsbyImageData(
                fit: FILL
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
              )
            }
          }
          bannerImage {
            asset {
              gatsbyImageData(
                fit: FILL
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
              )
            }
          }
          slug {
            current
          }
        }
      }
    }
  }
`
